import RGSProvider from "./RGS/RGSProvider";

let RGS = null;

const getRGS = async () => {
  if (!RGS) {
    try {
      RGS = RGSProvider.loadProvider();
    } catch (error) {
      throw error;
    }
  }
  return RGS;
};

export const handleInitGame = async () => {
  try {
    const rgs = await getRGS();
    const result = await rgs.initGame();
    return result;
  } catch (error) {
    throw error;
  }
};

export const handleSpin = async (bet, token, command, purchasedFeature) => {
  const rgs = await getRGS();
  try {
    const result = await rgs.spin(bet, token, command, purchasedFeature);
    return result;
  } catch (error) {
    throw error;
  }
};

export const handleSimulate = async (slotface, bet, token) => {
  const rgs = await getRGS();
  return await rgs.simulate(slotface, bet, token);
};
